import React from 'react';
import { Nav, Navbar, Form, Button } from 'react-bootstrap';
import { Link, useLocation, useHistory } from "react-router-dom";
import Cookies from 'universal-cookie';
import config from '../config';
import ReactGA from 'react-ga';
import axios from 'axios';

const Menu = () => {

  const history = useHistory();
  const location = useLocation();
  const cookies = new Cookies();

  function onClickLogout(evt) {
    const postData = {
      [config.accessTokenCookieKey]: cookies.get(config.accessTokenCookieKey)
    };
    console.debug('Menu onClickLogout postData=', postData);
    axios
      .post('/api/logout', postData, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
      .then((res) => {
        // console.debug('[Menu] /api/logout res=', res);
      })
      .catch((err) => {
        // console.error('/api/logout error=', err);
      })
      .then(() => {
        //
      });

    cookies.remove(config.accessTokenCookieKey, { path: '/' });

    ReactGA.event({
      category: 'Logout',
      action: 'Click',
      value: (cookies.get(config.accessTokenCookieKey) ? 0 : 1),
    });
    if (!cookies.get(config.accessTokenCookieKey)) {
      // stop sending username to Goolge Analytics for this browser session
      ReactGA.set({
        userId: undefined,
      });
    }

    // workaround for refreshing page to ensure user does not stay in a protected page
    //TODO: refactor with better design
    history.push(config.refreshPageLocation);
    setTimeout(() => {
      history.replace(location.pathname);
    }, 0)
  }

  return (
    <Navbar bg="light" variant="light" fixed="top">
      <Navbar.Brand as={Link} to="/docs">
        <img src="/img/prive-logo.png" className="menu-logo" alt="Privé" />
        {/* <span>Developer Portal</span> */}
      </Navbar.Brand>
      <Nav className="mr-auto" activeKey={location.pathname}>
        {/* <Nav.Link as={Link} to="/" eventKey="/">Home</Nav.Link> */}
        <Nav.Link as={Link} to="/docs" eventKey="/docs">API</Nav.Link>
      </Nav>
      <Form inline>
        <Button
          variant="outline-primary"
          size="sm"
          hidden={!cookies.get(config.accessTokenCookieKey)}
          onClick={onClickLogout}
        >
          Logout
        </Button>
      </Form>
    </Navbar>
  );
}

export default Menu;
